import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {items.map((item, i) => (
        <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-black/10">
          <AccordionTrigger
            data-testid={`faq-question-${i}`}
            className="py-6 text-left font-display text-lg font-medium text-ink transition-colors duration-200 hover:text-primary hover:no-underline md:text-xl"
          >
            {item.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 text-base leading-relaxed text-muted-foreground">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
